<template>
  <a-modal
    :title="'AI變裝功能教學'"
    v-model="localValue"
    :destroyOnClose="true"
    :centered="true"
    :maskClosable="false"
    :width="680"
    :footer="null"
    :closable="false"
    @cancel="handleCancel"
  >
    <a-row :gutter="16">
      <a-col :span="12" class="col">
        <p class="title">原圖</p>
        <img src="@/assets/img/AITutorialLeft.png" alt="AITutorialLeft" />
      </a-col>
      <a-col :span="12" class="col">
        <p class="title">AI變裝</p>
        <img src="@/assets/img/AITutorialRight.png" alt="AITutorialRight" />
      </a-col>
    </a-row>
    <ul class="style-list">
      <li
        v-for="item in style"
        :key="item.id"
        class="list-item"
        @click="selectStyle(item.id)"
      >
        <img
          :src="item.image_url"
          alt=""
          :class="[{ active: item.id == selectStyleID }, 'img']"
        />
        <p :class="[{ 'active-name': item.id == selectStyleID }, 'style-name']">
          {{ item.style_name }}
        </p>
      </li>
    </ul>
    <ul class="style-list">
      <li
        v-for="item in room"
        :key="item.id"
        class="list-item"
        @click="selectRoom(item.id)"
      >
        <button :class="[{ 'active-btn': item.id == selectRoomID }, 'btn']">
          {{ item.name }}
        </button>
      </li>
    </ul>
    <p class="info">選擇您想要的風格和空間，然後AI將為您生成相應的圖片。</p>
    <a-row>
      <a-col class="col" align="middle">
        <a-button type="primary" @click="handleCancel">我知道了</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      require: true,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      },
    },
  },
  data() {
    return {
      selectStyleID: 0,
      selectRoomID: 0,
      style: [
        {
          id: 0,
          style_name: '侘寂風',
          image_url: 'https://s3-fdi.s3.ap-southeast-1.amazonaws.com/web//o_1i2959v9t102kbj1gb21v0b1qeo4k.jpg',
        },
        {
          id: 1,
          style_name: '工業風',
          image_url: 'https://s3-fdi.s3.ap-southeast-1.amazonaws.com/web//o_1i5mntba81dno4kj1se2t4i1md88.png',
        },
        {
          id: 2,
          style_name: '歐式經典',
          image_url: 'https://s3-fdi.s3.ap-southeast-1.amazonaws.com/web//o_1i5mobjgcqg518r1154e10id16e211.png',
        },
        {
          id: 3,
          style_name: '歐式簡約',
          image_url: 'https://s3-fdi.s3.ap-southeast-1.amazonaws.com/web//o_1ibth33vr1u7q1enm174lq26v9f8.png',
        },
        {
          id: 4,
          style_name: '現代禪風',
          image_url: 'https://s3-fdi.s3.ap-southeast-1.amazonaws.com/web//o_1i295u1hv3231ee8qhs18us1jmn61.jpg',
        },
      ],
      room: [
        {
          id: 0,
          name: '臥室',
        },
        {
          id: 1,
          name: '客廳',
        },
      ],
    };
  },
  methods: {
    handleCancel() {
      this.localValue = false;
    },
    selectStyle(id) {
      this.selectStyleID = id;
    },
    selectRoom(id) {
      this.selectRoomID = id;
    },
  },
};
</script>
<style lang="less" scoped>
ul,
p {
  margin-bottom: 0;
}
.col {
  .title {
    margin-bottom: 10px;
  }
}
.style-list {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}
.list-item {
  max-width: 80px;
  cursor: pointer;
  & .img {
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    aspect-ratio: 1;
    margin-bottom: 7px;
  }
  & .style-name {
    text-align: center;
  }
  & .active-name {
    color: #015c61;
  }
  & .active {
    outline: 2px solid #015c61;
  }
}
.btn {
  padding: 10px 16px;
  font-size: 14px;
  color: #a7a7a7;
  border: 1px solid #a7a7a7;
  border-radius: 50px;
  background-color: #fff;
  cursor: pointer;
}
.active-btn {
  color: #015c61;
  border: 1px solid #015c61;
}
.info {
  color: #a7a7a7;
  margin: 20px 0 30px 0;
}
</style>
